import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export interface PaginacaoFiltro {
  page: number;
  pageSize: number;
  ordenation?: string;
}

@Injectable({ providedIn: 'root' })
export class PaginacaoFiltrosService {
  private paginacaoSubject = new BehaviorSubject<PaginacaoFiltro>({
    page: 1,
    pageSize: 50,
  });

  paginacao$ = this.paginacaoSubject.asObservable();

  setPaginacao(paginacao: PaginacaoFiltro) {
    this.paginacaoSubject.next(paginacao);
  }

  getPaginacao(): PaginacaoFiltro {
    return this.paginacaoSubject.getValue();
  }
}
